const CSRF_HEADER_NAME = 'X-XSRF-TOKEN';
const CSRF_RESPONSE_HEADER = 'X-CSRF-TOKEN';

let cachedCsrfToken: string | null = null;

export function getCsrfToken(): string | null {
  if (cachedCsrfToken) return cachedCsrfToken;

  // 跨域场景下 document.cookie 无法读取其他域的 cookie，
  // 必须通过 X-CSRF-TOKEN 响应头获取 token
  return null;
}

export function extractCsrfTokenFromResponse(response: Response): void {
  const token = response.headers.get(CSRF_RESPONSE_HEADER);
  if (token) {
    cachedCsrfToken = token;
  }
}

export function addCsrfToHeaders(headers: Record<string, string>): Record<string, string> {
  const csrfToken = getCsrfToken();
  if (csrfToken) {
    headers[CSRF_HEADER_NAME] = csrfToken;
  }
  return headers;
}

export function clearCachedCsrfToken(): void {
  cachedCsrfToken = null;
}
